import { ChevronDown } from "lucide-react";
import { ClassNameValue } from "tailwind-merge";

import { cn } from "./cn";

// 상태 다섯 톤. 색만으로 가르지 않는다 — 글자를 늘 같이 두고, hold·dropped 는 일부러 같은 색이다.
export const STATUS_TONES = ["new", "progress", "done", "hold", "dropped"] as const;

export type StatusTone = (typeof STATUS_TONES)[number];

// 클래스는 문자열 그대로 적는다 — 조립하면 Tailwind 가 스캔하지 못한다.
export const STATUS_TONE_CLASS: Record<StatusTone, string> = {
  new: "bg-status-new-bg text-status-new",
  progress: "bg-status-progress-bg text-status-progress",
  done: "bg-status-done-bg text-status-done",
  hold: "bg-status-hold-bg text-status-hold",
  dropped: "bg-status-dropped-bg text-status-dropped",
};

interface Props {
  tone: StatusTone;
  label: string;
  // 눌러서 바꾸는 자리면 테두리와 ▾ 로 「고를 수 있다」 를 모양으로 알린다.
  interactive?: boolean;
  className?: ClassNameValue;
}

const StatusBadge = ({ tone, label, interactive, className }: Props) => (
  <span
    className={cn(
      // 박스는 Pill 과 같다(tests/pill.test.ts) — 테두리는 크기가 안 변하는 안쪽 ring 으로
      "inline-flex items-center gap-x-1.5 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold",
      STATUS_TONE_CLASS[tone],
      interactive && "pr-1.5 ring-1 ring-inset ring-input hover:brightness-95 dark:hover:brightness-125",
      className
    )}>
    <span className="size-1.5 shrink-0 rounded-full bg-current" />
    {label}
    {interactive && <ChevronDown className="size-3 shrink-0 opacity-70" />}
  </span>
);

export default StatusBadge;
